import React from 'react';
import { Link } from 'react-router';
import SalesChannelModalComponent from './common/SalesChannelModalComponent';
import SchoolSelectionComponent from './common/SchoolSelectionComponent';
import $ from 'jquery';
import {canBulkUpload, getTrackingCode, getCsrToken, getAffiliateCode, getUserCode, isAdmin, isSchoolAdmin, isReadonly, checkOrg, isAgent} from '../helpers/access'
import {request} from '../helpers/request';
import {t} from '../helpers/translate'
import ModalComponent from './common/ModalComponent';
import { Table } from 'react-bootstrap'
const config = require('config');
const util = require('util')

class Sources extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      baseUrl: '',
      showSalesChannelModal: false,
      showSchoolModal: false,
      showProductModal: false,
      insurer: 'lloyds',
      sources: [],
      products: [],
      requestStatus: true
    };
  }

  componentWillMount() {
    this.loadData();
  }

  loadData() {
    $.when(request(`${config.default.api}/sources/`, 'GET', null, this.loadSources.bind(this))).done(this.updateRequestStatus.bind(this));
  }

  loadSources(responseData, statusCode) {
    if (statusCode == 200) {
      this.setState({
        sources: responseData.sources,
        products: responseData.products
      })
    }
  }

  updateRequestStatus (){
    this.setState({requestStatus: false})
  }

  onClickHandler(baseUrl, form, paymentType) {
    this.state.paymentType = paymentType;
    const formUrl = this.getFormLink(baseUrl, form);
    this.shouldOpenDirect() ? this.openForm(formUrl) : this.showSalesChannelModal(formUrl);
  }

  shouldOpenDirect() {
    return !isAdmin('ingle') && !(isSchoolAdmin() && sessionStorage.getItem('all_schools'));
  }

  openForm(baseUrl) {
    const formUrl = `${baseUrl}&sales_channel=online${getTrackingCode()}${getAffiliateCode()}${getUserCode(this.state.paymentType)}`;
    window.open(formUrl);
  }

  showSalesChannelModal(formUrl) {
    this.setState({
      baseUrl: formUrl,
      showSalesChannelModal: !isSchoolAdmin(),
      showSchoolModal: isSchoolAdmin(),
    });
  }
  
  showProductModal(title, body) {
    this.setState({
      showProductModal: true,
      modalBody: body,
      modalTitle: title,
    })
  }

  hideModal() {
    this.setState({
      showSalesChannelModal: false,
      showSchoolModal: false,
      showProductModal: false
    });
  }

  toggleInsurer(insurer) {
    this.setState({
      insurer: insurer
    })
  }

  getFormButtonText(form) {
    return t(form.name || 'Application Form');
  }

  renderApplicationFormButton(formPath, paymentType) {
    const baseUrl = config.default[sessionStorage.getItem('org')].form_base_url

    return <span>{!isReadonly() ? formPath.filter(form => form.link != null).map((form, idx) => (
      <span className="margin-search-policies">
        <div
          id={idx}
          className="btn button-primary button-minor mobile-top-padding"
          onClick={() => this.onClickHandler(baseUrl, form, paymentType)}><span className="fa fa-pencil-square-o fa-lg btn-app"></span>
          {this.getFormButtonText(form)}
        </div>
      </span>
    )) : null}
    </span>;
  }

  renderProductLinkButton(link) {
    let formLink = link.replace('{REFERRER_NAME}', getCsrToken())
    return <span className="margin-search-policies">
      <div
        className="btn button-primary button-minor mobile-top-padding"
        onClick={() => window.open(formLink)}><span className="fa fa-pencil-square-o fa-lg btn-app"></span>
        {t('Application Form')}
      </div>
    </span>
  }

  renderProductDocBtns(product) {
    let productUrls = Object.entries(product.urls);
    return <span>{productUrls.map(([label, link], idx) => (
      <span className="margin-search-policies">
        <div
          id={idx}
          className="btn button-primary button-minor mobile-top-padding"
          onClick={() => window.open(link)}><span className="fa fa-cloud-download fa-lg btn-app"></span>
          {t(label ? label : 'Rates')}
        </div>
      </span>
    ))}
  </span>
  }

  handlePolicyData(product) {
    this.showProductModal(t(product.product_name), this.showProductModalData(product))
  }

  quebecResidentsInfoLink() {
    return <p>For more information with regards to the name and contact information of the insurer, together with the warnings about the consequences of misrepresentation or concealment, please <a href='https://www.mshtravel.com/res/pdfs/general/QUEBEC_RESIDENTS_INFORMATION_ENG.pdf' target='_blank'>click here.</a></p>
  }

  showProductModalData(product) {
    const productUrls = Object.entries(product.urls);
    product.feature_details['Quebec Residents'] && (product.feature_details['Quebec Residents'] = this.quebecResidentsInfoLink());
    const featureDetails = Object.entries(product.feature_details);

    return (this.state.showProductModal = true) && <div>
      <h5 className="page-subtitle">{product.product_description}</h5>
      <div className="product-links">
        {productUrls.map(([label, link], i) =>
          <a href={link} key={i} target="_blank" className='link-space'><span className="fa fa-cloud-download link-space"></span>{label ? label : 'Rates'}</a>
        )}
      </div>
      <Table striped condensed hover bordered className="product-features">
        <thead>
          <tr>
            <td>{t('Benefit')}</td>
            <td>{t('Coverage Limit')}</td>
          </tr>
        </thead>
        <tbody>
          {featureDetails.map(([key, value], i) => {
            value = value.toString().includes('<br/>') ? value.split('<br/>').map((item, i) => <p key={i}>{item}</p>) : value;
            return (<tr key={i}>
                <td>{key}</td>
                <td>{value}</td>
              </tr>);
          })}
        </tbody>
      </Table>
    </div>
  }

  renderBulkUploadButton(upload_path, sourceItem) {
    return <span>{canBulkUpload() ? upload_path.filter(upload => upload.canUpload != false).map((upload, idx) => (
        <span className="margin-search-policies">
          <Link id={idx} className="btn button-primary button-minor" to={`/upload/${sourceItem.name}`}><span className="fa fa-upload fa-lg btn-icon"></span>{t('Bulk Upload')}</Link>
        </span>
      )) : null}
    </span>;
  }

  getFormLink(baseUrl, form) {
    return `${baseUrl}/${sessionStorage.getItem('locale')}/${form.link}`;
  }


  render() {
    const groupedProducts = _.groupBy(this.state.products, productItem => productItem.category_name);
    const categories = Object.entries(groupedProducts);
    return <div className="sources-layout">
      <div className='container'>
        <div className="text-center bg-inherit">
          <h2 className="page-title row">{t('Products')}</h2>
        </div>

        <div className="body">
          {this.state.sources.length || this.state.products.length ?
            <div className="margin-auto col-xs-12 col-sm-8">
              <SalesChannelModalComponent
                id='salesChannelModal'
                baseUrl={this.state.baseUrl}
                showModal={this.state.showSalesChannelModal}
                hideModal={this.hideModal.bind(this)}
              />

              <SchoolSelectionComponent 
                id='schoolSelectionModal' 
                baseUrl={this.state.baseUrl} 
                showModal={this.state.showSchoolModal} 
                hideModal={this.hideModal.bind(this)} 
                paymentType={this.state.paymentType} 
              />
              
              <table className="table table-hover product-subheading">
                <tbody>
                  {!(checkOrg('ingle') && isAgent()) && this.state.sources.map((sourceItem, i) => {
                    if (config.default.clients[sourceItem.name] !== undefined && sourceItem.active && (sourceItem.insurer == this.state.insurer)) {
                      const formPath = config.default.clients[sourceItem.name].form_path;
                      const uploadPath = config.default.clients[sourceItem.name].upload_path;
                      return (<tr key={i}>
                        <td>
                          <div className="form-control-static">{sourceItem.full_name} {sourceItem.category}</div>
                        </td>
                        <td>
                          <div className="btn-group pull-right mobile-pull-right">
                            {this.renderApplicationFormButton(formPath, sourceItem.payment_type)}
                            {this.renderBulkUploadButton(uploadPath, sourceItem)}
                          </div>
                        </td>
                      </tr>);
                    }
                  })}
                  {isAgent('ingle') && categories.map(([category, products], i) => {
                    return [(<tr key={i}>
                      <th><h3>{t(category)}</h3></th>
                    </tr>),
                    (products.map((product, i) => {
                      return (<tr key={i}>
                        <td>
                          <div className="form-control-static product-text" onClick={() => this.handlePolicyData(product)}>{product.product_name}</div>
                        </td>
                        <td>
                          <div className="btn-group pull-right mobile-pull-right">
                            {product.product_link && this.renderProductLinkButton(product.product_link)}
                            {this.renderProductDocBtns(product)}
                          </div>
                        </td>
                      </tr>)
                    }))];
                  })}
                </tbody>
              </table>
            </div>
            :
            <div className="well">{this.state.requestStatus ? t('Loading Products') : t('No client found')}</div>
          }
        </div>
      </div>

      <ModalComponent
        title={this.state.modalTitle}
        body={this.state.modalBody}
        onClose={this.hideModal.bind(this)}
        show={this.state.showProductModal}
      />
    </div>
  }
}

Sources.defaultProps = {};

export default Sources;



// WEBPACK FOOTER //
// ./src/components/Sources.js